module.exports = __webpack_public_path__ + "img/quality.b26e0d8f.svg";